export default "__VITE_ASSET__DO_TlW4e__"